import { bottomNav, brandInfo } from "../../../constant";
import { useElement, useLocale } from "../../../hooks";
import "./style.scss";

export const CopyrightSection = () => {
  const { t } = useLocale();
  const Link = useElement("Link");
  const renderBottomNav = () => {
    return (
      <ul className="bottom-nav">
        {bottomNav.map((e, i) => (
          <li key={i}>
            <Link href={e.link}>{e.label}</Link>
          </li>
        ))}
      </ul>
    );
  };
  return (
    <section>
      <div className="jumbo-container flex">
        {renderBottomNav()}
        <div className="copyright-area">
          <div className="copyright-area-inner">
            {t("copyRight")} &copy; {new Date().getFullYear()}{" "}
            {brandInfo.companyName} | {t("allRightsReserved")}.
          </div>
        </div>
      </div>
    </section>
  );
};
